export default __webpack_public_path__ + "static/media/microsoft_store_badge.b7eff2b0.png";